// src/redux/saga.ts
import { call, put, takeEvery } from 'redux-saga/effects';
import API from "core/networks/API";
import { AxiosResponse } from "axios";
import { IApiResponseSuccess } from "core/networks/Interfaces";
import {
  ISelectedImage,
  UPLOAD_IMAGE_REQUEST,
  uploadImageSuccess,
  uploadImageFailure,
} from './actions';
import { config } from 'core/config/app';

function* uploadImage(action: { type: string; payload: ISelectedImage }) {
  try {
    console.log('uploadImageSaga', action.payload);
    const formData = new FormData();
    formData.append('file', action.payload.file);
    formData.append('type', action.payload.type);
    formData.append('uuid', action.payload.uuid);

    const response: AxiosResponse<IApiResponseSuccess<any>> = yield call(
      API.upload,
      `${config.apiPrefix}/${config.apiVersion}/commons/upload-image`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );

    yield put(uploadImageSuccess(response.data.data));
  } catch (error: any) {
    const errorMessage = error.response?.data?.message || 'Upload failed';
    yield put(uploadImageFailure(action.payload, errorMessage));
  }
}

export default function* uploadImageSaga() {
  yield takeEvery(UPLOAD_IMAGE_REQUEST, uploadImage);
}
